import { UserType } from '@cnx-saas/common';

export enum Status {
  Active = 'Active',
  Inactive = 'Inactive',
}
export type User = {
  id: string;
  name: string;
  email: string;
  accountType: UserType;
  status: Status;
  isExist: boolean;
  invitedOn?: string;
};

export type InvitedUsers = {
  emails: string[];
  accountType: UserType;
};

export const getUserTypes = () =>
  Object.values(UserType).filter((value) => value !== UserType.BACK_OFFICE);
